@if (state === 'none') {
  <span class="yes-no-text">{{ text }}</span>
} @else {
  <span class="yes-no-pill" [class.yes-no-pill--yes]="state === 'yes'" [class.yes-no-pill--no]="state === 'no'">{{ text }}</span>
}
